import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";
import * as rx from "rxjs";

import type { ComputeRelevanceService } from "./service";
import type {
  PreviousPrompt,
  PROMPT_TYPE,
  RelevanceRubric,
} from "./service/types";

export const service = services.get<ComputeRelevanceService>(
  ServiceId.COMPUTE_RELEVANCE,
);

export function getDefaultPromptId(
  rubric: RelevanceRubric,
): Promise<string | null> {
  return rx.firstValueFrom(service.getDefaultPromptId(rubric));
}

export function fetchRecentPrompts(
  rubric: RelevanceRubric,
): Promise<(PreviousPrompt & { type: PROMPT_TYPE })[]> {
  return rx.firstValueFrom(service.fetchRecentPrompts(rubric));
}

export function deletePrompt(
  promptId: string,
  rubric: RelevanceRubric,
): Promise<(PreviousPrompt & { type: PROMPT_TYPE })[]> {
  return rx.firstValueFrom(service.deletePrompt(promptId, rubric));
}

export function setDefaultPromptId(
  rubric: RelevanceRubric,
  promptId: string | null,
): Promise<void> {
  return rx.firstValueFrom(service.setDefaultPromptId(rubric, promptId));
}
